import { createFileRoute, redirect } from '@tanstack/react-router'
import { AuthLayout } from '@/layouts/AuthLayout'
import { useAuthStore } from '@/store/auth.store'

export const Route = createFileRoute('/_auth')({
  beforeLoad: () => {
    const { accessToken, activeBusiness } = useAuthStore.getState()
    if (accessToken) {
      if (activeBusiness?.portal_only) throw redirect({ to: '/employee' })
      if (activeBusiness?.is_owner) throw redirect({ to: '/dashboard' })
      throw redirect({ to: '/sales', search: { tab: 'sales' } })
    }
  },
  component: AuthLayout,
})
